import service, { setAuthorizationToken } from '../config/axios.config';
import { addAlert } from './alerts.action';
import { setObjectiveLicences } from '../reducers/licencesSlice';
import { getUserInfo } from '../utils/language';
import { ALREADY_REGISTERED_ERROR } from '../utils/const';
import { logout } from '../utils/auth';
import { resetState } from '../actions/common.actions';

const alertMessageStart = 'registration.alert.';

export const CHECK_HASH_SUCCESS = 'cx-ray/EMPLOYEE/REGISTRATON/CHECK_HASH_SUCCESS';

export function checkHash(registrationHash, history) {
  return async dispatch => {
    const url = `/registration/${registrationHash}`;
    const token = localStorage.getItem('jwtToken');
    const handleLogOut = () => {
      logout();
      dispatch(resetState());
    };

    service.get(url)
      .then(result => {
        if (token) {
          handleLogOut();
        }

        dispatch({
          type: CHECK_HASH_SUCCESS,
          payload: result.data });
      })
      .catch(error => {
        if (error.message === ALREADY_REGISTERED_ERROR) {
          history.push('/objectives');
        } else {
          dispatch(
            addAlert({ message: `${alertMessageStart}${error.message}`, severity: 'error' })
          );
        }
      });
  };
};

export function createRegistration(registrationHash, registrationData, history) {
  return async dispatch => {
    const url = `/registration/${registrationHash}`;
    service.post(url, registrationData)
      .then(async result => {
        const token = result.data.token;

        localStorage.setItem('jwtToken', token);
        setAuthorizationToken(token);

        const { hasValidObjectiveManagementLicence } = await getUserInfo();
        dispatch(setObjectiveLicences(hasValidObjectiveManagementLicence));

        history.push('/objectives');
      })
      .catch(error => {
        dispatch(
          addAlert({ message: `${alertMessageStart}${error.message}`, severity: 'error' })
        );
      });
  };
};
